export default {
	title: 'Gestión de Terminales',
	actions: {
		add: 'Agregar',
		edit: 'Editar',
		delete: 'Eliminar',
		batchDelete: 'Eliminar en Lote'
	},
	messages: {
		deleteConfirm: '¿Está seguro de que desea eliminar los {count} registros seleccionados?',
		deleteSuccess: 'Operación exitosa',
		selectDeleteWarning: 'Por favor seleccione registros para eliminar',
		operateSuccess: 'Operación exitosa'
	},
	form: {
		projNo: 'Proyecto',
		transferProtocol: 'Protocolo de Transferencia',
		number: 'Número de Terminal',
		typeId: 'Tipo de Terminal',
		placeholder: {
			projNo: 'Por favor seleccione proyecto',
			transferProtocol: 'Por favor seleccione protocolo de transferencia',
			number: 'Por favor ingrese número de terminal',
			typeId: 'Por favor seleccione tipo de terminal'
		}
	},
	table: {
		number: 'Número de Terminal',
		projNo: 'N° de Proyecto',
		orgId: 'Organización',
		model: 'Modelo',
		upMode: 'Modo Ascendente',
		downMode: 'Modo Descendente',
		typeId: 'Tipo de Terminal',
		transferProtocol: 'Protocolo de Transferencia',
		ip: 'Dirección IP',
		maker: 'Fabricante',
		createTime: 'Fecha de Creación'
	},
	dialog: {
		add: 'Agregar',
		edit: 'Editar',
		cancel: 'Cancelar',
		confirm: 'Confirmar'
	},
	widgetForm: {
		projNo: 'Proyecto',
		orgId: 'Organización',
		typeId: 'Tipo de Terminal',
		maker: 'Fabricante',
		transferProtocol: 'Protocolo de Transferencia',
		model: 'Modelo',
		number: 'Número de Terminal',
		ip: 'Dirección IP',
		upMode: 'Modo Ascendente',
		downMode: 'Modo Descendente',
		attachmentList: 'Diagrama de Red',
		gridLayout: 'Diseño de Cuadrícula',
		requiredFieldCannotBeEmpty: 'El campo obligatorio no puede estar vacío',
		placeholder: {
			projNo: 'Por favor seleccione proyecto',
			orgId: 'Por favor seleccione organización',
			typeId: 'Por favor seleccione tipo de terminal',
			maker: 'Por favor ingrese fabricante',
			transferProtocol: 'Por favor seleccione protocolo de transferencia',
			model: 'Por favor ingrese modelo',
			number: 'Por favor ingrese número de terminal',
			ip: 'Por favor ingrese dirección IP',
			upMode: 'Por favor seleccione modo ascendente',
			downMode: 'Por favor seleccione modo descendente'
		}
	}
}
